<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Input the Transaction Code</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="{ id: transaction.id }"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-input name="key_code" label="Code" />
              </v-col>

              <v-col cols="12">
                <custom-button block color="primary">
                  Submit
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    transaction: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      key: 1,
    };
  },
  computed: {
    url() {
      return "api/v1/payments/verifyPayment";
    },
  },

  watch: {},
};
</script>
